import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import InventoryIcon from '@mui/icons-material/Inventory';
import CancelIcon from '@mui/icons-material/Cancel';
import dayjs from 'dayjs';

import Order from '../models/order';
import CheckIn from './CheckIn/CheckIn';

const StatCard = ({ title, value, icon }) => (
  <Card sx={{ height: '100%' }}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        {icon}
        <Typography variant="h6" component="div" sx={{ ml: 1 }}>
          {title}
        </Typography>
      </Box>
      <Typography variant="h4" color="primary">
        {value}
      </Typography>
    </CardContent>
  </Card>
);

const Home = () => {
  const [information, setInformation] = useState(null);

  useEffect(() => {
    const getInformation = async () => {
      const order = new Order();
      const res = await order.getMonthlyOrderReport();
      setInformation(res.data);
    };

    getInformation();
  }, []);

  const formatDate = (dateString) => {
    return dayjs(dateString).format('DD-MM-YYYY');
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        sx={{ textAlign: 'center' }}
      >
        {information?.period
          ? `Thống kê từ ngày ${formatDate(
            information.period.start_date
          )} đến ngày ${formatDate(information.period.end_date)}`
          : 'Thống kê'}
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Khách hàng gói tháng"
            value={information?.monthly_package_users || 0}
            icon={<PeopleIcon color="primary" sx={{ fontSize: 30 }} />}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Tổng số đơn hàng"
            value={information?.orders?.total || 0}
            icon={<ShoppingCartIcon color="primary" sx={{ fontSize: 30 }} />}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Số lượng sản phẩm"
            value={information?.quantities?.total || 0}
            icon={<InventoryIcon color="primary" sx={{ fontSize: 30 }} />}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Đơn hàng bị hủy"
            value={information?.cancelled_orders || 0}
            icon={<CancelIcon color="error" sx={{ fontSize: 30 }} />}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          Chi tiết đơn hàng
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell variant="head">Đơn hàng lẻ</TableCell>
                <TableCell>
                  {information?.orders?.by_type?.INSTANT_ORDER || 0}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Đơn hàng gói tháng</TableCell>
                <TableCell>
                  {information?.orders?.by_type?.MONTHLY_PACKAGE_ORDER || 0}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Số lượng sản phẩm từ đơn lẻ</TableCell>
                <TableCell>
                  {information?.quantities?.by_type?.INSTANT_ORDER || 0}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Số lượng sản phẩm từ gói tháng</TableCell>
                <TableCell>
                  {information?.quantities?.by_type?.MONTHLY_PACKAGE_ORDER || 0}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box sx={{ mt: 4 }}>
        <CheckIn />
      </Box>
    </Container>
  );
};

export default Home;
